import dayjs from "dayjs";

import { formatIdentifier } from "@/utils/formatIdentifier";
import { phoneFormat } from "@/utils/formatPhone";
import { addressConcat } from "@/utils/adreessConcat";
import { DetailedCitizenVaccinationsIndicatorC7Data } from "@/services/esus/indicator/esf/c7/getDetailedCitizensVaccinationsIndicatorC7";

import { IndicatorEsfC7CitizensVaccinationsHistoryInfo } from "./IndicatorEsfC7CitizensVaccinationsHistoryInfo";
import { VaccinationCard } from "@/components/VaccinationCard";

type IndicatorEsfC7CitizensVaccinationsHistoryProps = {
	citizenWithVaccinations: DetailedCitizenVaccinationsIndicatorC7Data;
};

export function IndicatorEsfC7CitizensVaccinationsHistory({
	citizenWithVaccinations,
}: Readonly<IndicatorEsfC7CitizensVaccinationsHistoryProps>) {
	const indicatorEsfC7CitizensVaccinationsHistoryInfo = {
		fullName: citizenWithVaccinations.fullName ?? "N/A",
		birthdate: citizenWithVaccinations.birthdate,
		document: citizenWithVaccinations.cpf
			? formatIdentifier(citizenWithVaccinations.cpf)
			: citizenWithVaccinations.cns ?? "",
		motherName: citizenWithVaccinations.motherName ?? "",
		phone: citizenWithVaccinations.phone ? phoneFormat(citizenWithVaccinations.phone) : "",
		address:
			addressConcat(
				citizenWithVaccinations.street,
				citizenWithVaccinations.houseNumber,
				citizenWithVaccinations.neighborhood
			) ?? "",
	};

	return (
		<>
			<IndicatorEsfC7CitizensVaccinationsHistoryInfo
				{...indicatorEsfC7CitizensVaccinationsHistoryInfo}
			/>
			<VaccinationCard
				vaccinations={(citizenWithVaccinations.vaccines ?? []).map((vaccine) => {
					return {
						id: vaccine.id,
						dateofVaccine: dayjs(vaccine.dateofVaccine).format("DD/MM/YYYY"),
						immunobiological: vaccine.immunobiological,
						immunobiologicalDosage: vaccine.immunobiologicalDosage,
						professional: vaccine.professional,
						healthTeam: vaccine.healthTeam,
						healthUnit: vaccine.healthUnit,
						status: "vaccinated",
						healthTeamId: vaccine.healthTeamId,
						healthUnitId: vaccine.healthUnitId,
					};
				})}
			/>
		</>
	);
}
